import { MY_TRIP_TABS } from "../component/TripManagement/myTripsPage/components/myTripsConstants";

export interface Attribution {
  source: "google" | "unsplash";
  photographerName: string | null;
  photographerUrl: string | null;
  downloadLocation: string | null;
}

export interface iCityDetailsResult {
  // complete_itinerary_description?: string;
  // city_wise_itinerary?: iCityItinerary[];
  complete_itinerary_flights_cost: {
    value: string;
    checkedFlag: boolean;
    id: string;
  };
  complete_itinerary_hotels_cost: {
    value: string;
    checkedFlag: boolean;
    id: string;
  };
  checkFlag?: any;
  city_type?: string;
  city_itinerary?: any;
  city_itinerary_description?: string;
  date?: string;
  averageCostAccommodation: string;
  averageCostOfFood: string;
  averagePackagePriceForExperiencing: string;
  checkedFlag: boolean;
  cityName: string;
  city_country_code: string;
  city_latitude: string;
  city_longitude: string;
  description: string;
  hotelName: string;
  imageURL: string;
  matchPercentage: string;
  id: string;
  minimum_cost_for_tour: string;
  locations: iCityDetailsResult[];
  tripDetails: any[];
  noOfDays: number;
  city_country?: string;
  city_name: string;
  city_state: string;
  destination_city?: string;
  destination_country?: string;
  destination_name?: string;
  activity_type?: string;
  time_of_the_day?: string;
}
export interface iSignUp {
  name?: string;
  email: string;
  password: string;
}
export interface iTripDetails {
  day: string;
  city_name: string;
  day_itinerary_description: string;
  itinerary_by_time_of_the_day_data?: iItineraryByTimeOfTheDay[];
}

export interface iItineraryByTimeOfTheDay {
  id: string;
  description: string;
  time_of_the_day: string;
  activity_type: string;
}

export interface iMyTripDetails {
  tripDate: string;
  travellersInfo: string;
  tripType: MY_TRIP_TABS;
  bookedOnDate: string;
  type?: string;
  tripsArr: iCityDetailsResult[];
}

/**0
 * Chat data Interface
 */
export interface iChatData {
  shouldNotShowFirstMessage?: boolean;
  isBookingFailed?: boolean;
  isBooking?: boolean;
  isProcessInterrupted?: boolean;
  isCompleteMessage?: boolean;
  isErrorMessage?: boolean;
  followUp?: boolean;
  id: string;
  chatTitle?: string;
  results?: any;
  isEdit?: boolean;
  estimatedPrice?: any;
  complete_itinerary_hotels_cost?: string;
  complete_itinerary_flights_cost?: string;
  itineraryPromptContext?: any;
  complete_itinerary_description?: string;
  city_wise_itinerary?: iCityItinerary[];
  tripName?: string;
  number_of_adults?: string;
  number_of_children?: string;
  number_of_senior_citizens?: string;
  international_trip?: boolean;
  airlines?: string;
  hotels?: string;
  start_date?: string;
  flight_day_part?: string;
  hotel_star_ratings?: string;
  flight_refundable?: string;
  hotel_refundable?: string;
  number_of_stops?: string;
  number_of_travelers?: string;
  prompt: any[];
  message: string;
  preText?: string;
  postText?: string;
  isUserMessage: boolean;
  isLoading: boolean;
  isItineraryStreaming?: boolean;
  attachedToChatId?: string;
  isStreaming?: boolean;
  responseType?: string;
  flightResponse?: any;
  hotelResponse?: any;
  activityResponse?: any;
  // Epoch-ms timestamp stamped when an in-chat flight/hotel/activity result
  // entry is finalized (see renderV2BlocksToChatEntry). Drives the 30-min
  // "results expired" gate in InChatFlightSearchResult / InChatHotelSearchResult
  // (utils/chatResultsExpiry.ts). Persisted with chatData, so reopening a stale
  // saved conversation still detects expiry. Optional → pre-feature entries
  // (and entries with no result) read as never-expired via Number.isFinite.
  resultsGeneratedAt?: number;
  searchProgressMessagesOnly?: boolean;
  // Echo of the `search_flights` tool_use input from the same turn. Captures
  // adults / children / infants / tripType / segments so the chat-side
  // flight card can show the right traveler count (without falling back to
  // bookingDetails defaults of 1 adult) and so the iteration knows whether
  // to render multi-city as one card per sector vs. one card per outbound
  // segment (the latter would explode multi-city into N one-way cards).
  flightSearchRequest?: {
    adults?: number;
    children?: number;
    infants?: number;
    tripType?: number; // 1 = one-way, 2 = round-trip, 3 = multi-city
    segments?: any[];
    cabin?: string;
    currency?: string;
  };
  // Echo of the `search_hotels` tool_use input from the same turn. Captures
  // the requested room count + guest counts (or a verbatim engine-shaped
  // roomInfo array) so the chat hotel card's room-pricing call reflects the
  // searched party (e.g. 2 rooms / 4 adults → noOfRooms:2) instead of falling
  // back to bookingDetails' single-room default. Parallel to flightSearchRequest.
  hotelSearchRequest?: {
    noOfRooms?: number;
    adults?: number;
    children?: number;
    infants?: number;
    seniors?: number;
    childrenAges?: number[] | string;
    roomInfo?: any[];
  };
  // In-chat flight-options card. Injected when the user clicks Select Flight
  // on an itinerary day-plan activity. The card collects filters (cabin,
  // stops, max price, optional dep/arr time ranges) and on Confirm sends a
  // natural-language search prompt via handleTopDestinationSendMessage —
  // the resulting flight tool-call cards render through the normal
  // flightResponse path. `dismissed` hides the card after Cancel/Confirm
  // so the entry remains in chat history but stops re-rendering controls.
  flightSelectCard?: {
    legContext: string;
    fromCity?: string;
    toCity?: string;
    date?: string;
    returnDate?: string;
    initial?: {
      cabin?: string;
      stops?: string;
      maxPrice?: string;
      depRange?: string;
      arrRange?: string;
    };
    dismissed?: boolean;
  };
  // In-chat hotel-options card. Mirrors flightSelectCard but for stays.
  // Injected when the user clicks Select Stay on an itinerary day-plan
  // activity. Basic view collects radius / star rating / max price;
  // Advanced adds hotel brand, accommodation type, and a Refundable
  // checkbox. On Confirm sends a natural-language search prompt.
  hotelSelectCard?: {
    city?: string;
    checkIn?: string;
    checkOut?: string;
    initial?: {
      radius?: string;
      stars?: string;
      maxPrice?: string;
      brand?: string;
      accommodationType?: string;
      refundable?: boolean;
    };
    dismissed?: boolean;
  };
  // V2 chat suggestion chips: 0-4 short prompts fetched from
  // POST /app/v1/poc/chat/suggestions after the assistant bubble lands.
  // Rendered under the latest turn only (see ChatArea.tsx).
  v2Suggestions?: string[];
  destinationList: iCityDetailsResult[];
  // singleSelectedDestination: iCityDetailsResult;
  singleSelectedDestination: boolean;
  noOfDays?: number;
  numberOfdays?: number;
  number_of_days?: number;
  number_of_travel_days?: string;
  hotel_user_ratings?: string;
  fromCity?: string;
  from?: string;
  from_latitude?: string;
  from_longitude?: string;
  from_country_code?: string;
  city_state?: string;
  itinerary_version?: number | string;
  iteneryInput?: any;
  isSaved?: boolean;
  isBooked?: boolean;
  isShared?: boolean;
  flight_cabin_class?: string;
  number_of_rooms?: string;
  departure_airport?: string;
  arrival_airport?: string;
  trip_type?: string;
  accomadation_types?: string;
  // Itinerary id stamped by cloneSharedTravelPlanIfNeeded after a /shared/:id
  // viewer's first interaction clones the source itinerary into their account.
  // Drives the Share button URL switch when USE_NEW_TABLE is on.
  travelPlanId?: string;
  // Source itinerary id captured by ViewShareItinerary when a /shared/:id URL
  // hydrates selectedChatData. The first chat send on a shared trip clones
  // that itinerary into the viewer's account, stamps the new id onto
  // travelPlanId, and clears this flag.
  sharedSourceTravelPlanId?: string;
  // V2 chat orchestrator trace. `agents` records which agent answered this
  // turn (poc_chat / conversation_stream_new / sibling-feature keys); v1 only
  // ever pushes one entry but the array preserves the option for multi-step
  // orchestration later. `router` records the orchestrator prompt that decided
  // the route (`poc_orchestration` for orchestrator-decided turns, omitted for
  // bypass/sibling turns). `traceId` is the per-turn id that joins FE
  // `[v2-orch]` logs to Lambda `[orch]` logs in CloudWatch.
  agents?: Array<{ key: string; version?: string; subTools?: string[] }>;
  router?: { key: string; version?: string };
  traceId?: string;
}
interface iCityItinerary {
  city_name: string;
  city_country: string;
  city_itinerary_description: string;
  city_itinerary: iDayItinerary[];
}

interface iDayItinerary {
  day: string;
  day_itinerary_description: string;
  itinerary_by_time_of_the_day_data: iTimeOfDayItinerary[];
}

interface iTimeOfDayItinerary {
  time_of_the_day: string;
  description: string;
}

export interface onBoardFormTypes {
  home: {
    city: string;
    state: string;
    country: string;
  };
  travelWith: string;
  lookingFor: [];
  budget: string;
  selectedBudget: number;
  isOfferAvailable: boolean;
  signUpOffer?: string | null;
}

/**
 *
 */
export interface iselectedChatData {
  chatDataId: string;

  city_country?: string;
  city_name?: string;

  averageCostAccommodation: string;
  averageCostOfFood: string;
  averagePackagePriceForExperiencing: string;
  checkedFlag: boolean;
  cityName: string;
  description: string;
  hotelName: string;
  imageURL: string;
  matchPercentage: string;
  id: string;
  minimum_cost_for_tour: string;
  locations: iCityDetailsResult[];

  countryName: string;
  detailsPrompt: string;
  // tripDetails: iTripForNDays[],
  tripDetails: any[];
  budgetEstimates: {
    flight: string;
    hotels: string;
    cars: string;
  };
}

export interface UpdateStateTypes {
  city: boolean;
  climate: boolean;
  population: boolean;
  exp: boolean;
  duration: boolean;
}

export interface UserInfo {
  id: string;
  name: string;
  email: string;
  phone: string;
  profile_pic: string | null;
  loggedIn: boolean;
  role: number;
  preferences?: any;
  existingUser?: boolean;
  loginType?: string;
}

export interface iAppConfig {
  id: string;
  key: string;
  value: string;
  description: string;
  status: boolean;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
}

export interface FaqItem {
  id: string;
  key: string;
  configCategory: string;
  title?: string;
  description?: string;
  value?: string;
  imageUrl?: string;
}

export interface ISelectedOptions {
  flights: boolean;
  hotels: boolean;
  activities?: boolean;
}

export interface Amenity {
  id: number;
  breakFast: string;
  pool: string;
  wifi: string;
}

export interface iAmenitiesIcons {
  name: string;
  icon: string;
}

export enum ToastType {
  SUCCESS,
  ERROR,
  WARNING,
  INFO,
  LOADING,
}

export interface ToastMessage {
  type: ToastType;
  message: string;
}

export type ToastMessages = {
  [key: string]: ToastMessage | ToastMessages;
};

export type ApiInfo =
  | "flight.search"
  | "flight.availability"
  | "flight.detail"
  | "hotel.search"
  | "hotel.detail"
  | "user.detail"
  | "user.update"
  | "user.create"
  | "user.login"
  | "user.logout"
  | "preference.details"
  | "preference.update"
  | "airport.search"
  | "category.details"
  | "config.details"
  | "prompt.details"
  | "dayplanning.details"
  | "reset.password"
  | "reset.passwordlink"
  | "user.sendpasswordlink"
  | "delete.history"
  | "viewfrequenttrip"
  | "view.history"
  | "itinerary.details"
  | "itinerary.list"
  | "recommended.list"
  | "weather.details"
  | "saveitinerary.details"
  | "delete.itinerary"
  | "modify.flight"
  | "cancel.flight"
  | "user.delete"
  | "traveler.form"
  | "share.via.email"
  | "baggage.fare"
  | "hotel.search.rooms"
  | "promo.code"
  | "prebooking"
  | "trip.summary"
  | "select.fare";

export type ApiErrorKey = `${
  | "flight.search"
  | "flight.availability"
  | "flight.detail"
  | "hotel.search"
  | "hotel.detail"
  | "user.detail"
  | "user.update"
  | "user.delete"
  | "user.create"
  | "user.login"
  | "user.logout"
  | "preference.details"
  | "preference.update"
  | "airport.search"
  | "category.details"
  | "config.details"
  | "prompt.details"
  | "dayplanning.details"
  | "reset.password"
  | "reset.passwordlink"
  | "user.sendpasswordlink"
  | "airport.search"
  | "delete.history"
  | "viewfrequenttrip"
  | "view.history"
  | "itinerary.details"
  | "itinerary.list"
  | "recommended.list"
  | "weather.details"
  | "delete.itinerary"
  | "modify.flight"
  | "cancel.flight"
  | "shareViaEmail"
  | "baggage.fare"
  | "traveler.form"
  | "promo.code"
  | "select.fare"
  | "trip.summary"
  | "saveitinerary.details"}.failure.${400 | 401 | 402 | 403 | 404 | 500 | 501 | 502 | 503 | 504}`;

export type ToastMessagesType = {
  [key in ApiErrorKey]?: { message: string; messageTitle: string };
} & {
  "api.break.down": { message: string; messageTitle: string };
};

export type dropDownType =
  | "date"
  | "airport"
  | "postBookingAirport"
  | "multiCityDate"
  | "multiCityHotelDate"
  | "roomDropDown"
  | "postBookingRoomDropDown"
  | "postBookingDropDown"
  | "postBookingHotelDropDown"
  | "postBookingHotelRightDropDown"
  | "oneway"
  | "cabinClass"
  | "room"
  | "onLyTraveler"
  | "postBookingFlightDate"
  | "activityRoom";
